module.exports = "/assets/data/2f9dcc78034e74344834efb4fea506e1-HU19.data.json";